export default __webpack_public_path__ + "static/media/japangot-logo.72f1b17d.png";